import React from 'react'
import { LANDING_PAGE_SECTIONS } from 'src/utils/paths'

import WelcomeSection from 'src/features/landingPage/components/WelcomeSection'
import HowItWorksSection from 'src/features/landingPage/components/HowItWorksSection'
import BenefitsSection from 'src/features/landingPage/components/BenefitsSection'
import HistorySection from 'src/features/landingPage/components/HistorySection'
import FaqSection from 'src/features/landingPage/components/FaqSection'
import ContactSection  from 'src/features/landingPage/components/ContactSection'

export const LandingPage = props => {
  return (
    <>
      <WelcomeSection />
      <div id={LANDING_PAGE_SECTIONS.howItWorksSection} />
      <HowItWorksSection />
      <div id={LANDING_PAGE_SECTIONS.benefitsSection} />
      <BenefitsSection />
      <div id={LANDING_PAGE_SECTIONS.history} />
      <HistorySection />
      <div id={LANDING_PAGE_SECTIONS.faq} />
      <FaqSection />
      <div id={LANDING_PAGE_SECTIONS.contactSection} />
      <ContactSection />
    </>
  )
}

export default LandingPage
